var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeterLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 20,
    viewBox: "0 0 54 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_20902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.07501V12.15L14.9472 12.1608L29.889 12.177L29.9053 16.0002L29.916 19.818H41.958H54V9.90901V0H27H0V6.07501ZM53.244 6.07501V11.394H27H0.756V6.07501V0.756H27H53.244V6.07501ZM34.992 15.606V17.064H36.369H37.746V17.469V17.874H35.802H33.858V16.011V14.148H34.425H34.992V15.606ZM39.582 16.011V17.874H39.015H38.448V16.011V14.148H39.015H39.582V16.011ZM42.093 15.5628L42.795 16.983L43.497 15.5628L44.1935 14.148H44.8363H45.4735L45.117 14.8068C44.9225 15.174 44.4798 16.011 44.1287 16.6698L43.497 17.874H42.795H42.093L41.499 16.7562C41.175 16.1406 40.7267 15.2982 40.5107 14.8932L40.1165 14.148H40.7537H41.3965L42.093 15.5628ZM50.112 14.499V14.85H48.627H47.142V15.228V15.606H48.573H50.004V15.957V16.308H48.573H47.142V16.713V17.118H48.627H50.112V17.496V17.874H48.06H46.008V16.011V14.148H48.06H50.112V14.499Z",
    fill: "#8E96A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 0H0V12.25H54V0Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88794 6.07497V8.26197H4.64394H5.39994L5.41074 7.38177L5.42694 6.50697H8.13234C10.7243 6.50697 10.8485 6.51237 10.9565 6.60957C11.1239 6.76077 11.1077 7.03617 10.9295 7.17657C10.7891 7.28997 10.7297 7.28997 8.34834 7.28997H5.91294L6.39894 7.77597L6.88494 8.26197H9.13134C11.2211 8.26197 11.4101 8.25657 11.7233 8.15397C12.1175 8.03517 12.4199 7.80837 12.5495 7.53837C12.6575 7.31157 12.6629 6.84717 12.5603 6.64737C12.4037 6.34497 12.0365 6.10197 11.6369 6.03717C11.5613 6.02637 11.6153 5.97777 11.8367 5.86977C12.2795 5.65377 12.4631 5.32437 12.3929 4.87617C12.3443 4.54677 12.0311 4.20657 11.6207 4.03917L11.3129 3.91497L7.60314 3.89877L3.88794 3.88257V6.07497ZM10.6325 4.91937C10.9619 5.03817 10.9619 5.43777 10.6325 5.55657C10.5137 5.59437 9.66054 5.61597 7.93254 5.61597H5.39994V5.23797V4.85997H7.93254C9.66054 4.85997 10.5137 4.88157 10.6325 4.91937Z",
    fill: "rgb(23,25,36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6728 4.38474L13.689 4.88694L17.7822 4.90314L21.87 4.91394V4.40094V3.88794H17.766H13.6566L13.6728 4.38474Z",
    fill: "rgb(23,25,36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6801 4.45494V5.02194H24.1219H25.5691L25.0021 4.45494L24.4351 3.88794H23.5603H22.6801V4.45494Z",
    fill: "rgb(23,25,36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.136 6.07494V8.26194H26.892H27.648L27.6587 6.65274L27.675 5.04894L29.3922 5.03274L31.104 5.02194V4.45494V3.88794H28.62H26.136V6.07494Z",
    fill: "rgb(23,25,36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.022 4.40094V4.91394H36.126H40.23V4.40094V3.88794H36.126H32.022V4.40094Z",
    fill: "rgb(23,25,36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.364 6.07497V8.26197H42.147H42.93V6.61497V4.96797H45.4303C46.98 4.96797 48.0005 4.98957 48.1248 5.02197C48.357 5.08677 48.492 5.24877 48.492 5.45937C48.492 5.92917 48.4435 5.93997 46.2943 5.93997H44.469L43.956 6.45297L43.443 6.96597H45.225H47.007L47.655 7.61397L48.303 8.26197H49.248H50.193L49.5018 7.57077L48.816 6.88497L49.0915 6.78237C49.7015 6.56637 50.112 5.91297 50.0365 5.27037C49.9715 4.69797 49.6315 4.29837 48.9943 4.03917L48.681 3.91497L45.0253 3.89877L41.364 3.88257V6.07497Z",
    fill: "rgb(23,25,36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.662 6.07501V6.58801H17.766H21.87V6.07501V5.56201H17.766H13.662V6.07501Z",
    fill: "rgb(23,25,36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.022 6.07501V6.58801H36.126H40.23V6.07501V5.56201H36.126H32.022V6.07501Z",
    fill: "rgb(23,25,36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6998 7.27376C13.6782 7.28996 13.662 7.52216 13.662 7.78676V8.26196H17.766H21.87V7.74896V7.23596H17.8038C15.5628 7.23596 13.716 7.25216 13.6998 7.27376Z",
    fill: "rgb(23,25,36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0597 7.27376C32.0382 7.28996 32.022 7.52216 32.022 7.78676V8.26196H36.126H40.23V7.74896V7.23596H36.1637C33.9227 7.23596 32.076 7.25216 32.0597 7.27376Z",
    fill: "rgb(23,25,36)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_20902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeterLive);
export default __webpack_public_path__ + "static/media/beterLive.e5a600124d4b2f4c3ba1927f9757611b.svg";
export { ForwardRef as ReactComponent };